import { createTranslations } from '@npco/common-utils-translations'

export const translations = createTranslations({
  title: 'Delete Item',
  body: 'Are you sure you want to delete {name}? This action cannot be undone.',
  success: '{name} has been deleted.',
  error: '{name} could not be deleted. Please try again.',
})
